<template lang='pug'>

	div
		ul.list-group.listagem-registros(v-if="grupos && grupos.length")

			li.list-group-item(v-for="g in grupos") 

				span.listagem-registros-titulo(:title="g.camada.nome") {{ g.camada.nome }}
				small.listagem-registros-subtitulo {{ g.quantidadeRegistros + (g.quantidadeRegistros > 1 ? ' registros' : ' registro') }}
				
				i.action-icon.fa.fa-chevron-right.pull-right(@click="exibirGrupo(g)")

		empty-result.full-height(message="Nenhum resultado encontrado.", v-if="grupos && grupos.length === 0")

</template>

<script>

import EmptyResult from '@/components/utils/EmptyResult';

export default {
	name: 'ListagemGruposRegistrosCamada',

	props: {
		grupos: Array
	},

	components: { EmptyResult },

	methods: {

		exibirGrupo (grupo) {

			this.$emit('exibirGrupo', { grupo: grupo });
		}
	}
};

</script>



// WEBPACK FOOTER //
// ListagemGruposRegistrosCamadas.vue?38dbe018